<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :filterOfFarms="false"
              :filterOfLots="false"
              :showDivision="true"
              :showHour="true"
              :showComparate="reportSel === 1 ? 1 : 2"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
            >
              <template slot="prev">
                <div class="col-12 col-md-3 col-lg-4 col-xl-2 pt-3">
                  <label for="">{{ $t('common_words.report_typeof') }} *</label>
                  <br />
                  <el-select
                    clearable
                    filterable
                    class="select-primary custom-width-select shadow-sm required-type"
                    v-model="reportSel"
                    :placeholder="`${$t('common_words.select')}...`"
                    @clear="reportData = []"
                    @change="handleChangeReport(1)"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in reportType"
                      :key="`${item.id}-${item.name}`"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
                <div class="col-12 col-md-9 col-lg-4 pt-3">
                  <label for="">{{ $t('devices.stations') }}: *</label>
                  <br />
                  <el-select
                    @change="
                      selectAllFromSelect('stationsSel', getStationsByReport);
                      handleChangeReport(1);
                    "
                    clearable
                    collapse-tags
                    style="width: 100%"
                    multiple
                    filterable
                    class="select-primary custom-width-select shadow-sm required-stations"
                    v-model="stationsSel"
                    :placeholder="`${$t('common_words.select')}...`"
                    @clear="reportData = []"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="item in getStationsByReport"
                      :key="`${item.id}-${item.name}`"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="col-12 col-md-6 col-lg-4 pt-3">
                  <label for="">{{ $t('devices.sensors') }}: *</label>
                  <br />
                  <el-select
                    @change="
                      selectAllFromSelect('sensorsSel', handleSensor);
                      handleChangeReport(0);
                    "
                    clearable
                    collapse-tags
                    style="width: 100%"
                    multiple
                    filterable
                    class="select-primary custom-width-select shadow-sm required-sensors"
                    v-model="sensorsSel"
                    :placeholder="`${$t('common_words.select')}...`"
                    @clear="reportData = []"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="item in handleSensor"
                      :key="`${item.id}-${item.two_name}`"
                      :label="item.two_name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="col-12 col-md-6 col-lg-4 col-xl-2 pt-3">
                  <label for="">{{
                    `${$t('common_words.crop')}: ${reportSel !== 3 ? '*' : ''}`
                  }}</label>
                  <br />
                  <el-select
                    clearable
                    style="width: 100%"
                    filterable
                    class="select-primary custom-width-select shadow-sm required-crops"
                    v-model="cropId"
                    :placeholder="`${$t('common_words.select')}...`"
                    @change="handleChangeReport(0)"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in crops"
                      :key="`${item.id}-${item.name}`"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <card v-if="validateData">
        <el-container>
          <aside-list
            @clickItem="loadData"
            :label="$t('devices.stations')"
            :list="stationsFiltered"
            v-if="stationsSel.length > 1"
          />
          <el-container>
            <el-main>
              <div class="row">
                <div class="col-12">
                  <card
                    class="custom-shadow-card-header"
                    v-if="
                      dataByStation.hcAirChart &&
                      dataByStation.hcAirChart.values.length > 0
                    "
                  >
                    <div class="row">
                      <chart-header-options
                        :chartData="chartOptions[0]"
                        :autoChange="false"
                        @handleLoadChartOptions="handleLoadChartOptions"
                      >
                        <template
                          slot="append"
                          v-if="
                            editBaseTempThreshold() &&
                            [1, 2].includes(reportSel)
                          "
                        >
                          <div
                            class="col-1"
                            style="width: 25px; flex: initial !important"
                            v-tooltip.bottom="getTooltip"
                          >
                            <temp-base-form
                              :cropId="dataByStation.cropId"
                              :cropName="getNameCrop"
                              :type="reportSel"
                              :minTemperature="getPropMinTempForm"
                              :maxTemperature="getPropMaxTempForm"
                              :isFahrenheit="dataByStation.fahrenheit"
                              @getDataReport="getDataReport"
                            />
                          </div>
                        </template>
                      </chart-header-options>
                      <div
                        class="col-1"
                        style="padding-top: 9px; padding-right: 27px"
                      >
                        <info-temp v-if="reportSel === 1" />
                        <info-chilling-unit v-if="reportSel === 2" />
                        <info-total-rain v-if="reportSel === 3" />
                      </div>
                      <div
                        class="col-12"
                        v-if="Object.keys(chartOptions[0]).length > 0"
                      >
                        <highcharts :options="chartOptions[0]"></highcharts>
                      </div>
                    </div>
                  </card>
                  <card
                    class="custom-shadow-card-header"
                    v-if="dataByStation.table && dataByStation.table.length > 0"
                  >
                    <card-header
                      :propPagination="pagination"
                      @searchedQuery="searchedQuery"
                      class="mr-3 mt-4"
                    >
                      <template v-if="dataFilter.comparate" slot="between">
                        <table-legend></table-legend>
                      </template>
                    </card-header>
                    <master-table
                      :objectSpanMethod="objectSpanMethod"
                      :infoTable="queriedData"
                      :columns="tableColumns"
                    />
                    <card-footer
                      ref="cardfooter"
                      :propPagination="pagination"
                    />
                    <export-tables
                      :pdf="{
                        filename: `${$t('climate.accumulator')}.pdf`,
                        route: 'climates/accumulator/pdf',
                        paramMethod: 'POST',
                        plusData: { ...getDataToExport },
                      }"
                      :xls="{
                        filename: `${$t('climate.accumulator')}.xlsx`,
                        route: 'climates/accumulator/excel',
                        paramMethod: 'POST',
                        plusData: { ...getDataToExport },
                      }"
                    />
                    <br />
                  </card>
                </div>
              </div>
            </el-main>
          </el-container>
        </el-container>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Chart } from 'highcharts-vue';
import { Pagination as LPagination } from 'src/components/index';
import { Switch as LSwitch } from 'src/components';
import configTable from './accumulator-table';
import AsideList from 'src/components/Layouts/AsideList.vue';
import ChartHeaderOptions from 'src/components/Chart/ChartHeaderOptions.vue';
import ComparateFormatter from './ComparateFormatter';
import Filter from 'src/components/Filter/Filters.vue';
import Fuse from 'fuse.js';
import InfoChillingUnit from './InfoChillingUnit.vue';
import InfoTemp from './InfoTemp.vue';
import InfoTotalRain from './InfoTotalRain.vue';
import MixinCharts from 'src/util/mixinCharts';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import TableLegend from './TableLegend.vue';
import TempBaseForm from './TempBaseForm.vue';
import i18n from 'src/i18n';

export default {
  components: {
    [AsideList.name]: AsideList,
    [ChartHeaderOptions.name]: ChartHeaderOptions,
    [Filter.name]: Filter,
    [InfoChillingUnit.name]: InfoChillingUnit,
    [InfoTemp.name]: InfoTemp,
    [InfoTotalRain.name]: InfoTotalRain,
    [TableLegend.name]: TableLegend,
    [TempBaseForm.name]: TempBaseForm,
    highcharts: Chart,
    LPagination,
    LSwitch,
  },

  data() {
    return {
      activeName: 'filter',
      chartOptions: [],
      dataByStation: [],
      dataFilter: {
        datef: moment().format('YYYY-MM-DD'),
        datei: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        comparate: false,
      },
      cropId: null,
      crops: [],
      pagination: {},
      reportData: [],
      reportSel: null,
      sensors: [],
      valueCollapse: null,
      sensorsSel: [],
      stations: [],
      stationsSel: [],
      tableColumns: [],
      tmpPlotBands: {},
    };
  },

  mixins: [MixinMenu, MixinMasters, MixinCharts, MixinPermissions],

  watch: {
    '$i18n.locale': 'updateTableColumns',
  },

  computed: {
    validateData() {
      try {
        return Object.values(this.reportData).length > 0;
      } catch (error) {
        return false;
      }
    },

    reportType() {
      return [
        { id: 1, name: i18n.t('climate.heat'), sensor: 'air' },
        { id: 2, name: i18n.t('climate.cold'), sensor: 'air' },
        { id: 3, name: i18n.t('climate.rain'), sensor: 'precipitation' },
      ];
    },

    getStationsByReport() {
      const result = this.stations.filter((station) => {
        switch (this.reportSel) {
          case 1:
          case 2:
            return (
              station.climate_sensors &&
              station.climate_sensors.some((sensor) =>
                sensor.name.includes('Air')
              )
            );

          case 3:
            return (
              station.climate_sensors &&
              station.climate_sensors.some((sensor) =>
                sensor.name.includes('Precipitation')
              )
            );
          default:
            break;
        }
      });

      return this.concatAll(result);
    },

    getTooltip() {
      const propMap = {
        1: i18n.t('climate.base_temperature_upper_threshold'),
        2: i18n.t('climate.max_temperature_lower_threshold'),
      };

      return propMap[this.reportSel] || {};
    },

    getPropMinTempForm() {
      const propMap = {
        1: {
          value: this.dataByStation.baseTemperature,
          label: i18n.t('climate.base_temperature'),
        },
        2: {
          value: this.dataByStation.coldThreshold,
          label: i18n.t('climate.lower_threshold'),
        },
      };

      return propMap[this.reportSel] || {};
    },

    getPropMaxTempForm() {
      const propMap = {
        1: {
          value: this.dataByStation.upperThreshold,
          label: i18n.t('climate.upper_threshold'),
        },
        2: {
          value: this.dataByStation.coldMaximum,
          label: i18n.t('climate.maximum_temperature'),
        },
      };

      return propMap[this.reportSel] || {};
    },

    getNameCrop() {
      if (this.cropId) {
        const crop = this.crops.find((crop) => crop.id === this.cropId);
        return crop.name;
      }

      return 'NA';
    },

    getDataToExport() {
      const response = { ...this.dataFilter };
      delete response.route;

      return response;
    },

    stationsFiltered() {
      try {
        const stations = Object.keys(this.reportData).map((key) => Number(key));
        return this.stations.filter((station) => {
          return stations.includes(station.id);
        });
      } catch (error) {
        return [];
      }
    },

    handleSensor() {
      try {
        if (this.reportSel) {
          const report = this.reportType.find(
            (type) => type.id === this.reportSel
          );
          const response = this.sensors.filter((sensor) => {
            if (sensor.stations) {
              return (
                sensor.name.trim().toLowerCase().includes(report.sensor) &&
                sensor.stations.some((station) =>
                  this.stationsSel.includes(station)
                )
              );
            }
          });

          if (response.length === 1) {
            this.sensorsSel.push(response[0].id);
          }

          return this.concatAll(response, 'two_name');
        } else this.concatAll([]);
      } catch (error) {
        return this.concatAll([]);
      }
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },

    getTableColumn() {
      let result = [];
      switch (this.reportSel) {
        case 1:
          result = [...configTable().Table.heatColumnTable].map((column) => {
            if (
              [
                'formatted_date',
                'degreeHours',
                'degreeDays',
                'degreeDaysAcc',
              ].includes(column.prop)
            ) {
              column.formatter = this.dataFilter.comparate
                ? ComparateFormatter
                : configTable().formatterFuction;
            }
            return column;
          });
          break;
        case 2:
          result = [...configTable().Table.coldColumnTable].map((column) => {
            if (
              ['date', 'numberHours', 'hours72C', 'utah', 'pcuUtah'].includes(
                column.prop
              )
            ) {
              column.formatter = this.dataFilter.comparate
                ? ComparateFormatter
                : configTable().formatterFuction;
            }
            return column;
          });
          break;
        default:
          result = [...configTable().Table.rainColumnTable].map((column) => {
            if (['formatted_date', 'sum'].includes(column.prop)) {
              column.formatter = this.dataFilter.comparate
                ? ComparateFormatter
                : configTable().formatterFuction;
            }
            return column;
          });
          break;
      }

      this.tableColumns = result;

      return result;
    },
  },

  methods: {
    openTempBase() {
      document.getElementsByClassName('el-icon-setting')[0].click();
    },

    updateTableColumns() {
      this.tableColumns = this.getTableColumn;
    },

    handleChangeReport(type) {
      this.reportData = [];
      switch (type) {
        case 1:
          this.sensorsSel = [];
          break;
        case 2:
          this.stationsSel = [];
          break;

        default:
          break;
      }
    },

    objectSpanMethod({ row, columnIndex }) {
      if ([5, 6].includes(columnIndex)) {
        const date = moment(row.formatted_date).format('YYYY-MM-DD');
        const rowspan = this.dataByStation.rowSpanDate[date];

        return {
          rowspan: rowspan ? rowspan : 1,
          colspan: 1,
        };
      }
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleLoadChartOptions(data) {
      this.$set(this.chartOptions, data.index, data.chartData);
    },

    handleFilter(data) {
      this.reportData = [];
      this.dataFilter = { ...data };

      if (this.dataFilter.bySel === 'Año') {
        this.dataFilter.datei = moment(this.dataFilter.datei).format(
          'YYYY-MM-DD'
        );
        this.dataFilter.datef = moment(this.dataFilter.datef)
          .endOf('year')
          .format('YYYY-MM-DD');
      }

      if (!this.reportSel) {
        this.validationInputsRequired('type');
      } else if (this.stationsSel.length === 0)
        this.validationInputsRequired('stations');
      else if (this.sensorsSel.length === 0)
        this.validationInputsRequired('sensors');
      else if (!this.cropId && this.reportSel !== 3)
        this.validationInputsRequired('crops');
      else this.getDataReport();
    },

    loadData(data) {
      const { id, type } = data;
      if (type && type === 'aside' && !this.reportData[id]) {
        SweetAlert.warning(i18n.t('common_words.unavailable_data'));
        this.dataByStation = [];
      }

      this.tableColumns = this.getTableColumn;
      if (this.reportData[id]) {
        this.dataByStation = this.reportData[id];
        this.dataByStation.stationId = id;

        this.tableData = this.dataByStation.table;
        this.chartOptions[0] = this.lines(
          this.dataByStation.hcAirChart,
          false,
          500,
          false
        );

        this.fuseSearch = new Fuse(this.tableData, {
          useExtendedSearch: true,
          threshold: 0.3,
          keys: this.tableColumns.map((prop) => {
            return prop.prop;
          }),
        });

        setTimeout(() => {
          let tspan = document
            .getElementsByClassName('highcharts-subtitle')[0]
            .getElementsByTagName('tspan');
          tspan = [...tspan];
          tspan.shift();
          tspan.forEach((span) => {
            span.addEventListener('click', this.openTempBase);
          });
          this.updateDataPagination(
            'cardfooter',
            [this.from, this.to, this.total],
            5
          );
        }, 300);
      }
    },

    getDataReport(loading = true) {
      this.pagination.perPage = 10;
      this.pagination.currentPage = 1;
      this.searchQuery = '';

      if (loading) {
        this.reportData = [];
        this.dataByStation = [];
        this.showHideLoading(true);
      }

      let data = this.dataFilter;
      data.route = 'climates/accumulator';
      data.stations = this.stationsSel;
      data.sensors = this.sensorsSel;
      data.report = this.reportSel;

      if (this.cropId) data.cropId = this.cropId;

      Axios.postMasters(data)
        .then((response) => {
          const { data: dataResponse } = response;
          const { data } = dataResponse;
          Object.entries(data).forEach((item) => {
            if (item[1].table.length > 0) {
              const resp = {};
              resp[item[0]] = item[1];
              this.reportData = { ...this.reportData, ...resp };
            }
          });

          if (Object.keys(this.reportData).length > 0) {
            if (this.stationsSel.length > 1) {
              setTimeout(() => {
                const aside = document.getElementsByClassName(
                  'el-menu-item custom-el-menu-item-cal'
                )[0];
                aside.click();
              }, 100);
            } else {
              this.loadData({
                id: Number(Object.keys(this.reportData)[0]),
                type: 'auto',
              });
            }
          } else {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
            this.reportData = [];
            this.dataByStation = [];
          }

          if (loading) this.showHideLoading();
        })
        .catch((error) => {
          if (error.response.status === 300) {
            this.showHideLoading();
            SweetAlert.select(
              'Listado de cultivos',
              error.response.data.message,
              'Continuar',
              error.response.data.data
            ).then((success) => {
              this.cropId = Number(success.value);
              this.getDataReport(loading);
            });
          } else {
            if (loading) this.showHideLoading();
            this.showMessageErrors(error);
          }
        });
    },

    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    this.setupTable();
    Promise.all([
      Axios.getMasters('devices/stations/accumulator'),
      Axios.getMasters('devices/sensors/toSelect/all/name|Air-Precipitation'),
      Axios.getMasters('farms/crops'),
    ]).then((response) => {
      const [responseStations, responseSensors, responseCrops] = response;
      this.stations = this.concatAll(responseStations.data.data);
      this.sensors = responseSensors.data.data;
      this.crops = responseCrops.data.data;
    });
  },

  mounted() {
    this.selectedItemOnMenu('climates');
  },

  destroyed() {
    this.deselectedItemOnMenu('climates');
  },
};
</script>
